import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Table,
  Form,
  Button,
  Spinner,
  Tabs,
  Tab,
} from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import Cookies from "universal-cookie";
import moment from 'moment-timezone';
const timeZone = 'America/Tegucigalpa'; // GMT-6
const API_HOST = process.env.REACT_APP_API_URL;
const API = process.env.REACT_APP_API_KEY;

const cookies = new Cookies();

const Reporte = () => {
  const nowInZone = moment.tz(timeZone).toDate(); // Obtiene la fecha actual en zona -6

  const [fecha, setFecha] = useState(nowInZone);
  const [fechaInicio, setFechaInicio] = useState(nowInZone);
  const [fechaFin, setFechaFin] = useState(nowInZone);
  const [datos, setDatos] = useState([]);
  const [datosDetallados, setDatosDetallados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingDetallado, setLoadingDetallado] = useState(false);
  const [usuarios, setUsuarios] = useState({});
  const [activeTab, setActiveTab] = useState("cierre");
  const [tipoReporteDetallado, setTipoReporteDetallado] = useState("diario");

  const fetchDatos = async () => {
    const bearertoken = cookies.get("token");
    setLoading(true);
    try {
      const fechaFormateada = moment(fecha).tz("America/Tegucigalpa").startOf('day').format("YYYY-MM-DD");

      const response = await fetch(
        `${API_HOST}/facturas/reporteFactura/${fechaFormateada}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${bearertoken}`,
            API: API,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Error: No se encontraron facturas del día seleccionado ${response.status}`);
      }

      const result = await response.json();

      if (!result.success) {
        throw new Error(result.message || "Error al obtener datos");
      }

      procesarDatos(result.data);
      Swal.fire({
        icon: "success",
        title: "Datos cargados",
        text: `Se encontraron ${result.data.length} facturas para esta fecha`,
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Error al obtener datos:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "No se pudieron cargar los datos",
      });
    } finally {
      setLoading(false);
    }
  };const fetchDatosDetallados = async () => {
    const bearertoken = cookies.get("token");
    setLoadingDetallado(true);
    
    try {
      // Validar que fechaInicio esté definida
      if (!fechaInicio) {
        throw new Error("Debe seleccionar una fecha de inicio");
      }

      // Validar rango de fechas si es necesario
      if (tipoReporteDetallado === "rango" && !fechaFin) {
        throw new Error("Debe seleccionar una fecha de fin para el rango");
      }

      if (tipoReporteDetallado === "rango" && moment(fechaFin).isBefore(fechaInicio)) {
        throw new Error("La fecha fin no puede ser anterior a la fecha inicio");
      }

      // Formatear fechas en formato ISO (YYYY-MM-DD)
      const fechaInicioFormateada = moment(fechaInicio).format("YYYY-MM-DD");
      let url = `${API_HOST}/facturas/reporteFactura/${fechaInicioFormateada}`;

      if (tipoReporteDetallado === "rango") {
        const fechaFinFormateada = moment(fechaFin).format("YYYY-MM-DD");
        url += `/${fechaFinFormateada}`;
      }

      // Agregar parámetro de zona horaria
      url += `?timezone=America/Tegucigalpa`;

      // Mostrar URL en consola para depuración
      console.log("URL de solicitud:", url);

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${bearertoken}`,
          API: API,
          'Content-Type': 'application/json'
        },
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `Error HTTP: ${response.status}`);
      }

      const result = await response.json();

      if (!result.success) {
        throw new Error(result.message || "Error al obtener datos detallados");
      }

      // Procesar los datos recibidos
      const datosProcesados = result.data.map(item => ({
        ...item,
        // Convertir fechas UTC a local si es necesario
        fecha: moment.utc(item.fecha).tz('America/Tegucigalpa').format('DD/MM/YYYY HH:mm:ss')
      }));

      setDatosDetallados(datosProcesados);
      
      Swal.fire({
        icon: "success",
        title: "Datos cargados",
        text: `Se encontraron ${result.data.length} facturas ${
          tipoReporteDetallado === "rango"
            ? "en el rango seleccionado"
            : "para esta fecha"
        }`,
        timer: 2000,
        showConfirmButton: false,
      });

    } catch (error) {
      console.error("Error al obtener datos detallados:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "No se pudieron cargar los datos detallados",
        confirmButtonText: "Entendido"
      });
    } finally {
      setLoadingDetallado(false);
    }
  };

  const procesarDatos = (facturas) => {
    const usuariosMap = {};

    // Filtrar solo facturas activas para los cálculos
    const facturasActivas = facturas.filter(
      (factura) => factura.factura.estado === "Activa"
    );

    facturasActivas.forEach((factura) => {
      const usuarioId = factura.usuario.id_Usuario;
      const nombreUsuario = factura.usuario.nombre_Completo;
      const metodoPago = factura.factura.metodoPago;
      const totalFactura = factura.ordenPaquete.ordenes.reduce(
        (sum, orden) => sum + parseFloat(orden.total || 0),
        0
      );

      if (!usuariosMap[usuarioId]) {
        usuariosMap[usuarioId] = {
          nombre: nombreUsuario,
          efectivo: 0,
          transferencia: 0,
          tarjeta: 0,
          total: 0,
          facturas: 0,
        };
      }

      switch (metodoPago.toLowerCase()) {
        case "efectivo":
          usuariosMap[usuarioId].efectivo += totalFactura;
          break;
        case "transferencia":
        case "transferencia bancaria":
          usuariosMap[usuarioId].transferencia += totalFactura;
          break;
        case "tarjeta":
        case "tarjeta de crédito":
        case "tarjeta de débito":
          usuariosMap[usuarioId].tarjeta += totalFactura;
          break;
        default:
          usuariosMap[usuarioId].efectivo += totalFactura;
          break;
      }

      usuariosMap[usuarioId].total += totalFactura;
      usuariosMap[usuarioId].facturas += 1;
    });

    setUsuarios(usuariosMap);
    setDatos(facturas); // Guardamos TODAS las facturas (activas y anuladas)
  };

  const generarPDFCierre = () => {
    try {
      const doc = new jsPDF();
      doc.setProperties({
        title: `Reporte de Cierre - ${fecha.toLocaleDateString()}`,
        subject: "Reporte diario de cierre",
        author: "Sistema de Facturación",
      });

      // Título
      doc.setFontSize(18);
      doc.setTextColor(40, 40, 40);
      doc.text("Reporte Información de Cierre", 105, 15, null, null, "center");

      // Subtítulo
      doc.setFontSize(12);
      doc.text(`Fecha: ${fecha.toLocaleDateString()}`, 14, 25);
      doc.text(
        `Total Facturas: ${datos.length} (Activas: ${Object.values(
          usuarios
        ).reduce((sum, user) => sum + user.facturas, 0)})`,
        14,
        32
      );

      // Tabla principal (solo activas)
      autoTable(doc, {
        startY: 40,
        head: [
          [
            "Usuario",
            "Facturas Activas",
            "Efectivo",
            "Transferencia",
            "Tarjeta",
            "Total",
          ],
        ],
        body: Object.values(usuarios).map((user) => [
          user.nombre,
          user.facturas,
          `L. ${user.efectivo.toFixed(2)}`,
          `L. ${user.transferencia.toFixed(2)}`,
          `L. ${user.tarjeta.toFixed(2)}`,
          `L. ${user.total.toFixed(2)}`,
        ]),
        headStyles: {
          fillColor: [41, 128, 185],
          textColor: 255,
          fontStyle: "bold",
        },
        alternateRowStyles: {
          fillColor: [245, 245, 245],
        },
        columnStyles: {
          0: { cellWidth: 50 },
          1: { cellWidth: 20 },
          2: { cellWidth: 30 },
          3: { cellWidth: 30 },
          4: { cellWidth: 30 },
          5: { cellWidth: 30 },
        },
      });

      // Totales (solo activas)
      const totalEfectivo = Object.values(usuarios).reduce(
        (sum, user) => sum + user.efectivo,
        0
      );
      const totalTransferencia = Object.values(usuarios).reduce(
        (sum, user) => sum + user.transferencia,
        0
      );
      const totalTarjeta = Object.values(usuarios).reduce(
        (sum, user) => sum + user.tarjeta,
        0
      );
      const granTotal = Object.values(usuarios).reduce(
        (sum, user) => sum + user.total,
        0
      );

      autoTable(doc, {
        startY: doc.lastAutoTable.finalY + 10,
        body: [
          [
            "Total Facturas Activas",
            Object.values(usuarios).reduce(
              (sum, user) => sum + user.facturas,
              0
            ),
          ],
          ["Total Efectivo", `L. ${totalEfectivo.toFixed(2)}`],
          ["Total Transferencia", `L. ${totalTransferencia.toFixed(2)}`],
          ["Total Tarjeta", `L. ${totalTarjeta.toFixed(2)}`],
          ["Gran Total", `L. ${granTotal.toFixed(2)}`],
          ["", ""],
          [
            "Total Facturas Anuladas",
            datos.filter((f) => f.factura.estado === "Anulada").length,
          ],
        ],
        columnStyles: {
          0: { fontStyle: "bold", cellWidth: 60 },
          1: { fontStyle: "bold", halign: "right", cellWidth: 40 },
        },
        margin: { left: 100 },
      });

      // Pie de página
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(10);
        doc.setTextColor(150);
        doc.text(
          `Página ${i} de ${pageCount}`,
          doc.internal.pageSize.width - 40,
          doc.internal.pageSize.height - 10
        );
      }
      const fechaFormateada = moment(fecha).tz("America/Tegucigalpa").format("YYYY-MM-DD");
      doc.save(`reporte_cierre_${fechaFormateada}.pdf`);
    } catch (error) {
      console.error("Error al generar PDF:", error);
      Swal.fire({
        icon: "error",
        title: "Error al generar PDF",
        text: "Ocurrió un problema al generar el documento",
      });
    }
  };

  const generarPDFDetallado = () => {
    try {
      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
      });

      doc.setProperties({
        title: `Reporte Detallado - ${fechaInicio.toLocaleDateString()}${
          tipoReporteDetallado === "rango"
            ? ` a ${fechaFin.toLocaleDateString()}`
            : ""
        }`,
        subject: "Reporte detallado de facturas",
        author: "Sistema de Facturación",
      });

      // Título
      doc.setFontSize(14);
      doc.text("REPORTE DETALLADO DE FACTURAS", 140, 15, { align: "center" });

      // Subtítulo
      doc.setFontSize(10);
      doc.text(
        `Fechas: ${fechaInicio.toLocaleDateString()}${
          tipoReporteDetallado === "rango"
            ? ` - ${fechaFin.toLocaleDateString()}`
            : ""
        }`,
        15,
        22
      );
      doc.text(
        `Total facturas: ${datosDetallados.length} (Activas: ${
          datosDetallados.filter((f) => f.factura.estado === "Activa").length
        })`,
        250,
        22
      );

      // Preparar datos para la tabla (todas las facturas)
      const body = datosDetallados.map((factura) => {
        const correlativoSar = factura.informacionSar.correlativo || "";
        const correlativoFactura = factura.factura.correlativo
          .toString()
          .padStart(8, "0");

        // Calcular totales (solo para activas)
        const subtotal =
          factura.factura.estado === "Activa"
            ? factura.ordenPaquete.ordenes.reduce(
                (sum, orden) => sum + parseFloat(orden.subtotal || 0),
                0
              )
            : 0;
        const isv =
          factura.factura.estado === "Activa"
            ? factura.ordenPaquete.ordenes.reduce(
                (sum, orden) => sum + parseFloat(orden.isv || 0),
                0
              )
            : 0;
        const descuento =
          factura.factura.estado === "Activa"
            ? factura.ordenPaquete.ordenes.reduce(
                (sum, orden) => sum + parseFloat(orden.descuento || 0),
                0
              )
            : 0;
        const total =
          factura.factura.estado === "Activa"
            ? factura.ordenPaquete.ordenes.reduce(
                (sum, orden) => sum + parseFloat(orden.total || 0),
                0
              )
            : 0;

        return [
          `${correlativoSar}-${correlativoFactura}`,
          new Date(factura.factura.fechaEmision).toLocaleDateString(),
          factura.usuario.nombre_Completo,
          factura.ordenPaquete.cliente.nombre,
          factura.rtnInfo?.rtn?.rtn || factura.ordenPaquete.cliente.identidad,
          factura.factura.tipoCliente,
          factura.factura.metodoPago,
          factura.factura.estado,
          factura.factura.estado === "Activa"
            ? `L. ${subtotal.toFixed(2)}`
            : "N/A",
          factura.factura.estado === "Activa" ? `L. ${isv.toFixed(2)}` : "N/A",
          factura.factura.estado === "Activa"
            ? `L. ${descuento.toFixed(2)}`
            : "N/A",
          factura.factura.estado === "Activa"
            ? `L. ${total.toFixed(2)}`
            : "N/A",
        ];
      });

      // Generar tabla
      autoTable(doc, {
        startY: 30,
        head: [
          [
            "No. Factura",
            "Fecha",
            "Usuario",
            "Cliente",
            "Identificación",
            "Tipo",
            "Pago",
            "Estado",
            "Subtotal",
            "ISV",
            "Desc.",
            "Total",
          ],
        ],
        body: body,
        headStyles: {
          fillColor: [41, 128, 185],
          textColor: 255,
          fontStyle: "bold",
        },
        alternateRowStyles: {
          fillColor: [240, 240, 240],
        },
        margin: { left: 10 },
        styles: {
          fontSize: 7,
          cellPadding: 2,
          overflow: "linebreak",
        },
        columnStyles: {
          6: { cellWidth: 15 }, // Estado
          7: { halign: "right" }, // Subtotal
          8: { halign: "right" }, // ISV
          9: { halign: "right" }, // Descuento
          10: { halign: "right" }, // Total
        },
      });

      // Calcular totales generales (solo activas)
      const facturasActivas = datosDetallados.filter(
        (f) => f.factura.estado === "Activa"
      );

      const granSubtotal = facturasActivas.reduce((sum, factura) => {
        return (
          sum +
          factura.ordenPaquete.ordenes.reduce(
            (sumOrden, orden) => sumOrden + parseFloat(orden.subtotal || 0),
            0
          )
        );
      }, 0);

      const granISV = facturasActivas.reduce((sum, factura) => {
        return (
          sum +
          factura.ordenPaquete.ordenes.reduce(
            (sumOrden, orden) => sumOrden + parseFloat(orden.isv || 0),
            0
          )
        );
      }, 0);

      const granDescuento = facturasActivas.reduce((sum, factura) => {
        return (
          sum +
          factura.ordenPaquete.ordenes.reduce(
            (sumOrden, orden) => sumOrden + parseFloat(orden.descuento || 0),
            0
          )
        );
      }, 0);

      const granTotal = facturasActivas.reduce((sum, factura) => {
        return (
          sum +
          factura.ordenPaquete.ordenes.reduce(
            (sumOrden, orden) => sumOrden + parseFloat(orden.total || 0),
            0
          )
        );
      }, 0);

      autoTable(doc, {
        startY: doc.lastAutoTable.finalY + 10,
        body: [
          ["Total Facturas Activas", facturasActivas.length],
          [
            "Total Facturas Anuladas",
            datosDetallados.length - facturasActivas.length,
          ],
          ["", ""],
          ["Subtotal General", `L. ${granSubtotal.toFixed(2)}`],
          ["ISV General", `L. ${granISV.toFixed(2)}`],
          ["Descuento General", `L. ${granDescuento.toFixed(2)}`],
          ["Total General", `L. ${granTotal.toFixed(2)}`],
        ],
        columnStyles: {
          0: { fontStyle: "bold", cellWidth: 60 },
          1: { fontStyle: "bold", halign: "right", cellWidth: 40 },
        },
        margin: { left: 100 },
      });

      // Pie de página
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(10);
        doc.setTextColor(150);
        doc.text(
          `Página ${i} de ${pageCount}`,
          doc.internal.pageSize.width - 40,
          doc.internal.pageSize.height - 10
        );
      }

      doc.save(
        `reporte_detallado_${fechaInicio.toISOString().split("T")[0]}${
          tipoReporteDetallado === "rango"
            ? `_a_${fechaFin.toISOString().split("T")[0]}`
            : ""
        }.pdf`
      );
    } catch (error) {
      console.error("Error al generar PDF detallado:", error);
      Swal.fire({
        icon: "error",
        title: "Error al generar PDF",
        text: "Ocurrió un problema al generar el documento detallado",
      });
    }
  };

  // Función para obtener el color según el estado
  const getEstadoColor = (estado) => {
    return estado === "Activa" ? "success" : "danger";
  };

  return (
    <Container className='mt-4'>
      <Tabs
        activeKey={activeTab}
        onSelect={(k) => setActiveTab(k)}
        className='mb-3'
      >
        <Tab eventKey='cierre' title='Reporte de Cierre'>
          <Card>
            <Card.Header
              as='h5'
              className='d-flex justify-content-between align-items-center'
            >
              Reporte Información de Cierre
              <Button
                variant='primary'
                onClick={generarPDFCierre}
                disabled={Object.keys(usuarios).length === 0}
              >
                <i className='bi bi-file-earmark-pdf me-2'></i> Generar PDF
              </Button>
            </Card.Header>
            <Card.Body>
              <Form>
                <Row className='mb-4'>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Seleccione una fecha</Form.Label>
                      <DatePicker
                        selected={fecha}
                        onChange={(date) => setFecha(date)}
                        className='form-control'
                        dateFormat='dd/MM/yyyy'
                        maxDate={new Date()}
                        isClearable
                        placeholderText='Seleccione una fecha'
                      />
                    </Form.Group>
                  </Col>
                  <Col md={2} className='d-flex align-items-end'>
                    <Button
                      variant='primary'
                      onClick={fetchDatos}
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <Spinner
                            as='span'
                            animation='border'
                            size='sm'
                            role='status'
                            aria-hidden='true'
                            className='me-2'
                          />
                          Cargando...
                        </>
                      ) : (
                        <>
                          <i className='bi bi-search me-2'></i> Generar Reporte
                        </>
                      )}
                    </Button>
                  </Col>
                </Row>
              </Form>
              {Object.keys(usuarios).length > 0 ? (
                <>
                  <div className='mb-3'>
                    <h6>Resumen del día: {fecha.toLocaleDateString()}</h6>
                    <p className='mb-0'>
                      <strong>Total Facturas:</strong> {datos.length} |
                      <strong> Activas:</strong>{" "}
                      {Object.values(usuarios).reduce(
                        (sum, user) => sum + user.facturas,
                        0
                      )}{" "}
                      |<strong> Anuladas:</strong>{" "}
                      {datos.length -
                        Object.values(usuarios).reduce(
                          (sum, user) => sum + user.facturas,
                          0
                        )}
                    </p>
                  </div>
                  <Table striped bordered hover responsive className='mt-3'>
                    <thead className='table-dark'>
                      <tr>
                        <th>Usuario</th>
                        <th>Facturas Activas</th>
                        <th>Efectivo</th>
                        <th>Transferencia</th>
                        <th>Tarjeta</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.values(usuarios).map((usuario, index) => (
                        <tr key={index}>
                          <td>{usuario.nombre}</td>
                          <td className='text-center'>{usuario.facturas}</td>
                          <td className='text-end'>
                            L. {usuario.efectivo.toFixed(2)}
                          </td>
                          <td className='text-end'>
                            L. {usuario.transferencia.toFixed(2)}
                          </td>
                          <td className='text-end'>
                            L. {usuario.tarjeta.toFixed(2)}
                          </td>
                          <td className='text-end fw-bold'>
                            L. {usuario.total.toFixed(2)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot className='table-secondary'>
                      <tr>
                        <td className='fw-bold'>Totales</td>
                        <td className='text-center fw-bold'>
                          {Object.values(usuarios).reduce(
                            (sum, user) => sum + user.facturas,
                            0
                          )}
                        </td>
                        <td className='text-end fw-bold'>
                          L.{" "}
                          {Object.values(usuarios)
                            .reduce((sum, user) => sum + user.efectivo, 0)
                            .toFixed(2)}
                        </td>
                        <td className='text-end fw-bold'>
                          L.{" "}
                          {Object.values(usuarios)
                            .reduce((sum, user) => sum + user.transferencia, 0)
                            .toFixed(2)}
                        </td>
                        <td className='text-end fw-bold'>
                          L.{" "}
                          {Object.values(usuarios)
                            .reduce((sum, user) => sum + user.tarjeta, 0)
                            .toFixed(2)}
                        </td>
                        <td className='text-end fw-bold text-success'>
                          L.{" "}
                          {Object.values(usuarios)
                            .reduce((sum, user) => sum + user.total, 0)
                            .toFixed(2)}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan='6' className='text-center fw-bold'>
                          Facturas Anuladas:{" "}
                          {datos.length -
                            Object.values(usuarios).reduce(
                              (sum, user) => sum + user.facturas,
                              0
                            )}
                        </td>
                      </tr>
                    </tfoot>
                  </Table>
                </>
              ) : (
                <div className='text-center py-4'>
                  <i className='bi bi-file-earmark-excel display-5 text-muted'></i>
                  <p className='mt-3 text-muted'>
                    No hay datos para mostrar. Seleccione una fecha y genere el
                    reporte.
                  </p>
                </div>
              )}
            </Card.Body>
          </Card>
        </Tab>
        <Tab eventKey='detallado' title='Reporte Detallado'>
          <Card>
            <Card.Header
              as='h5'
              className='d-flex justify-content-between align-items-center'
            >
              Reporte Detallado de Facturas
              <Button
                variant='primary'
                onClick={generarPDFDetallado}
                disabled={datosDetallados.length === 0}
              >
                <i className='bi bi-file-earmark-pdf me-2'></i> Generar PDF
              </Button>
            </Card.Header>
            <Card.Body>
              <Form>
                <Row className='mb-4'>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>Tipo de Reporte</Form.Label>
                      <Form.Select
                        value={tipoReporteDetallado}
                        onChange={(e) =>
                          setTipoReporteDetallado(e.target.value)
                        }
                      >
                        <option value='diario'>Diario</option>
                        <option value='rango'>Por Rango de Fechas</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={tipoReporteDetallado === "diario" ? 3 : 2}>
                    <Form.Group>
                      <Form.Label>
                        {tipoReporteDetallado === "diario"
                          ? "Fecha"
                          : "Fecha Inicio"}
                      </Form.Label>
                      <DatePicker
                        selected={fechaInicio}
                        onChange={(date) => setFechaInicio(date)}
                        className='form-control'
                        dateFormat='dd/MM/yyyy'
                        maxDate={new Date()}
                        isClearable
                        placeholderText='Seleccione fecha'
                      />
                    </Form.Group>
                  </Col>
                  {tipoReporteDetallado === "rango" && (
                    <Col md={2}>
                      <Form.Group>
                        <Form.Label>Fecha Fin</Form.Label>
                        <DatePicker
                          selected={fechaFin}
                          onChange={(date) => setFechaFin(date)}
                          className='form-control'
                          dateFormat='dd/MM/yyyy'
                          maxDate={new Date()}
                          minDate={fechaInicio}
                          isClearable
                          placeholderText='Seleccione fecha'
                        />
                      </Form.Group>
                    </Col>
                  )}
                  <Col md={2} className='d-flex align-items-end'>
                    <Button
                      variant='primary'
                      onClick={fetchDatosDetallados}
                      disabled={loadingDetallado}
                    >
                      {loadingDetallado ? (
                        <>
                          <Spinner
                            as='span'
                            animation='border'
                            size='sm'
                            role='status'
                            aria-hidden='true'
                            className='me-2'
                          />
                          Cargando...
                        </>
                      ) : (
                        <>
                          <i className='bi bi-search me-2'></i> Generar Reporte
                        </>
                      )}
                    </Button>
                  </Col>
                </Row>
              </Form>
              {datosDetallados.length > 0 ? (
                <>
                  <div className='mb-3'>
                    <h6>
                      Resumen{" "}
                      {tipoReporteDetallado === "diario"
                        ? "del día"
                        : "del rango"}
                      : {fechaInicio.toLocaleDateString()}
                      {tipoReporteDetallado === "rango"
                        ? ` - ${fechaFin.toLocaleDateString()}`
                        : ""}
                    </h6>
                    <p className='mb-0'>
                      <strong>Total Facturas:</strong> {datosDetallados.length}{" "}
                      |<strong> Activas:</strong>{" "}
                      {
                        datosDetallados.filter(
                          (f) => f.factura.estado === "Activa"
                        ).length
                      }{" "}
                      |<strong> Anuladas:</strong>{" "}
                      {
                        datosDetallados.filter(
                          (f) => f.factura.estado === "Anulada"
                        ).length
                      }
                    </p>
                  </div>
                  <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                    {datosDetallados.map((factura, index) => (
                      <Card key={index} className='mb-3'>
                        <Card.Header
                          className={`bg-${getEstadoColor(
                            factura.factura.estado
                          )}`}
                        >
                          <div className='d-flex justify-content-between'>
                            <div>
                              <strong>
                                Factura #
                                {factura.informacionSar.correlativo +
                                  "-" +
                                  factura.factura.correlativo
                                    .toString()
                                    .padStart(8, "0")}
                              </strong>{" "}
                              -{" "}
                              {new Date(
                                factura.factura.fechaEmision
                              ).toLocaleDateString()}
                            </div>
                            <div>
                              <strong>Estado: {factura.factura.estado}</strong>
                              {factura.factura.estado === "Activa" && (
                                <span className='ms-2'>
                                  <strong>
                                    Total: L.{" "}
                                    {factura.ordenPaquete.ordenes
                                      .reduce(
                                        (sum, orden) =>
                                          sum + parseFloat(orden.total),
                                        0
                                      )
                                      .toFixed(2)}
                                  </strong>
                                </span>
                              )}
                            </div>
                          </div>
                        </Card.Header>
                        <Card.Body>
                          <Row>
                            <Col md={6}>
                              <p>
                                <strong>Cliente:</strong>{" "}
                                {factura.ordenPaquete.cliente.nombre}
                              </p>
                              <p>
                                <strong>RTN/Identidad:</strong>{" "}
                                {factura.rtnInfo?.rtn?.rtn ||
                                  factura.ordenPaquete.cliente.identidad}
                              </p>
                              <p>
                                <strong>Método Pago:</strong>{" "}
                                {factura.factura.metodoPago}
                              </p>
                            </Col>
                            <Col md={6}>
                              <p>
                                <strong>Usuario:</strong>{" "}
                                {factura.usuario.nombre_Completo}
                              </p>
                              <p>
                                <strong>Correlativo SAR:</strong>{" "}
                                {factura.informacionSar.correlativo}
                              </p>
                            </Col>
                          </Row>
                          {factura.factura.estado === "Activa" && (
                            <>
                              <Table striped bordered hover className='mt-3'>
                                <thead>
                                  <tr>
                                    <th>Tracking</th>
                                    <th>Tipo Envío</th>
                                    <th>Peso (lbs)</th>
                                    <th>Subtotal</th>
                                    <th>ISV</th>
                                    <th>Descuento</th>
                                    <th>Total</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {factura.ordenPaquete.ordenes.map(
                                    (orden, idx) => (
                                      <tr key={idx}>
                                        <td>{orden.paquete.tracking}</td>
                                        <td>{orden.paquete.tipoEnvio}</td>
                                        <td>{orden.paquete.pesoMbox}</td>
                                        <td className='text-end'>
                                          L.{" "}
                                          {parseFloat(orden.subtotal).toFixed(
                                            2
                                          )}
                                        </td>
                                        <td className='text-end'>
                                          L. {parseFloat(orden.isv).toFixed(2)}
                                        </td>
                                        <td className='text-end'>
                                          L.{" "}
                                          {parseFloat(orden.descuento).toFixed(
                                            2
                                          )}
                                        </td>
                                        <td className='text-end fw-bold'>
                                          L.{" "}
                                          {parseFloat(orden.total).toFixed(2)}
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                                <tfoot>
                                  <tr className='table-secondary'>
                                    <td
                                      colSpan='6'
                                      className='text-end fw-bold'
                                    >
                                      Total Factura
                                    </td>
                                    <td className='text-end fw-bold'>
                                      L.{" "}
                                      {factura.ordenPaquete.ordenes
                                        .reduce(
                                          (sum, orden) =>
                                            sum + parseFloat(orden.total),
                                          0
                                        )
                                        .toFixed(2)}
                                    </td>
                                  </tr>
                                </tfoot>
                              </Table>
                            </>
                          )}
                          {factura.factura.estado === "Anulada" && (
                            <div className='alert alert-warning mt-3'>
                              <strong>Factura Anulada</strong> - No se incluye
                              en los totales
                            </div>
                          )}
                        </Card.Body>
                      </Card>
                    ))}
                  </div>
                </>
              ) : (
                <div className='text-center py-4'>
                  <i className='bi bi-file-earmark-text display-5 text-muted mb-3'></i>
                  <p>
                    No hay datos para mostrar. Seleccione una fecha y haga clic
                    en "Generar Reporte".
                  </p>
                </div>
              )}
            </Card.Body>
          </Card>
        </Tab>
      </Tabs>
    </Container>
  );
};

export default Reporte;
